import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';
import { ServicesContext } from 'services/context';
import CommentToDoManager from './managers/todo';
import './markAsDoneButton.html';
import './markAsDoneButton.scss';
import CommentRequestButtonVM, { CommentRequestButtonVMConfig } from './requestButton';

@injectable()
export default class CommentMarkAsDoneButtonVM extends CommentRequestButtonVM {
    private commentId: Subscribable<string | undefined>
    private topicId: Subscribable<string | undefined>

    private isInToDoList: Subscribable<boolean>
    private isReported: Subscribable<boolean>

    isVisible = ko.pureComputed(() => this.checkIfCanBeMarkedDone())

    constructor(
        @inject(wccModules.componentConfig) config: CommentRequestButtonVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager,
        @inject(wccModules.servicesContext) private ctx: ServicesContext
    ) {
        super(config, info);

        this.commentId = this.comment.pluck(c => c.id);
        this.topicId = this.comment.pluck(c => c.topicId);

        const todoManager = new CommentToDoManager(this.comment, storage);
        this.isInToDoList = todoManager.isInToDoList;
        this.isReported = todoManager.isReported;

        ko.applyBindingsToNode(info.element, {
            'css': {
                'topic__comment__mark-as-done-button': true
            }
        }, this);
    }

    markAsDone = async () => {
        if (this.isLocked()) return;

        this.isBusy(true);

        try {
            const commentId = this.commentId();
            const topicId = this.topicId();

            if (commentId == undefined || topicId == undefined)
                throw new Error(messages.InvalidRequest);

            await this.ctx.commentsService.markAsDone(topicId, commentId);
        } catch (ex) {
            system.handleError(ex);
        } finally {
            this.isBusy(false);
        }
    }

    private checkIfCanBeMarkedDone() {
        if (!this.isLocked())
            return this.isInToDoList() && !this.isReported();

        return false;
    }
}